module.exports = __webpack_public_path__ + "/images/shop/icon/arrow_group.svg";